import axios from "axios";
/**
 * List of endpoint const's
 */
export const LOGIN = "/login";
export const LOGOUT = "/logout";
export const USER = "/api/user";
export const VALIDATE = "/api/form/{form}/{step}";
export const FORM = "/api/form/{form}";
export const COMPANY = "/api/company";
export const COMPANY_SEARCH = "/api/company/search?query={query}";
export const COMPANY_LOCATION = "/api/company/location/{number}";
export const CLAIM_SPECIFICATION = "/api/claim-specification";
export const endpoint = (endpoint, data) => {
    Object.keys(data).map((key) => (endpoint = endpoint.replace("{" + key + "}", data[key])));
    return endpoint;
};
/**
 * Set default bearer on all Axios requests
 */
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// Add a response interceptor
axios.interceptors.response.use(undefined, (error) => {
    const httpError = {
        status: error.response.status,
        message: error.response.data.message || error.message || "",
        fieldErrors: {},
        genericErrors: [],
        original: error,
    };
    if (!httpError.status) {
        // Translate network error
        httpError.message = "Netwerkfout";
    }
    if (httpError.status === 422) {
        httpError.fieldErrors = error.response.data.errors;
    }
    else {
        httpError.genericErrors =
            (error.response.data && error.response.data.errors) || {};
    }
    return Promise.reject(httpError);
});
export default axios;
